import gql from 'graphql-tag';

export default gql`
  query encryptData($input: EncryptDataInput) {
    encryptData(input: $input) {
      encryptedData
    }
  }
`;



// WEBPACK FOOTER //
// ./src/app/queries/getEncryptedData.js